import { render, staticRenderFns } from "./ModalBankAccountTransferForm.vue?vue&type=template&id=52547545&scoped=true"
import script from "./ModalBankAccountTransferForm.vue?vue&type=script&lang=js"
export * from "./ModalBankAccountTransferForm.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/bank-account-transfer-modals.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ModalBankAccountTransferForm.vue?vue&type=style&index=1&id=52547545&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52547545",
  null
  
)

export default component.exports